import { Grid } from '@mui/material';
import { CardAssist } from './CardAssist';
import { useEffect, useState } from 'react';
import { getPublicParameters } from '@shared/services/services';

import { sxStyle } from './styles';

export const SearchResultsAssist = ({
  searchResults,
  setIsLoadingResults,
  xTransactionId,
}) => {
  const [searchResultsFiltered, setSearchResultsFiltered] = useState(
    searchResults
  );
  const [canBuy, setCanBuy] = useState(true);
  const [canEmitToAccount, setCanEmitToAccount] = useState(true);

  const [filterValue] = useState('');

  const handleFilter = () => {
    const filteredResults = searchResults.filter(item =>
      item.nombreProducto.toLowerCase().includes(filterValue.toLowerCase())
    );
    setSearchResultsFiltered(filteredResults);
  };

  useEffect(() => {
    fetchPublicParameters();
  }, []);

  useEffect(() => {
    setIsLoadingResults(true);
    if (filterValue.length >= 2) {
      handleFilter();
    } else {
      setSearchResultsFiltered(searchResults);
    }
    setIsLoadingResults(false);
  }, [filterValue, searchResults]);

  const fetchPublicParameters = async () => {
    const params = {
      parameter_types: 5,
    };
    const response = await getPublicParameters(params);

    setCanBuy(response.find(x => x.name === 'salesAssistCard')?.value);
    setCanEmitToAccount(response.find(x => x.name === 'bookAssistCard')?.value);
  };

  const searchResultsByAgreement = [
    ...searchResultsFiltered.sort(
      (a, b) => a.price.details.total - b.price.details.total
    ),
  ];

  return (
    <Grid container className="minWebPadding" sx={sxStyle.root}>
      <Grid container item xs={12} lg={12}>
        <Grid container>
          {searchResultsByAgreement?.map((element, idx) => (
            <CardAssist
              element={element}
              canBuy={canBuy}
              canEmitToAccount={canEmitToAccount}
              key={idx}
              xTransactionId={xTransactionId}
            />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
